module.exports = __webpack_public_path__ + "img/mnu_logo.73f48561.jpg";